<template>
  <div class="table-list">
    <!-- 标题 -->
    <div
      class="title-area"
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
      "
    >
      <span v-if="title" :style="{ fontSize: '16px', fontWeight: 'bold', ...titleStyle }">
        {{ title }}
      </span>
      <slot name="titleRightExtra"></slot>
    </div>
    <!-- 筛选区域 -->
    <slot name="queryArea"></slot>
    <!-- 选择区域 -->
    <div
      v-if="showSelectRowTip && rowSelection.selectedRowKeys.length > 0"
      class="ant-alert ant-alert-info"
      style="margin-bottom: 16px"
    >
      <i class="anticon anticon-info-circle ant-alert-icon"></i>
      已选择
      <a style="font-weight: 600">{{ rowSelection.selectedRowKeys.length }}</a>
      项
      <a style="margin-left: 24px" @click="clearSelected">清空</a>
    </div>
    <a-table
      :bordered="bordered"
      :class="{ 'curr-table': !bordered, 'j-table-force-nowrap': scroll.x }"
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      :pagination="pagination"
      :rowKey="rowKey"
      :rowSelection="rowSelection"
      :scroll="scroll"
      :size="size"
      :rowClassName="rowClassName"
      v-bind="attrs"
      @change="change"
    >
      <!-- prettier-ignore -->
      <template v-for="(item, index) in soltNames" v-slot:[item]="text, record">
        <slot :index="index" :name="item" :record="record" :text="text">
          <!--ranking排名插槽默认内容-->
          <template v-if="isShowRank && item === 'ranking'">
            <div :key="index" class="ranking-cell">
              <div :class="{ frontIndex: text < 4 }" class="text">
                {{ text }}
              </div>
              <img
                :src="require('@assets/schoolChangeTrend/lineChangImg.png')"
                alt=""
                class="chart"
                @click="chartClick(record)"
              />
            </div>
          </template>
          <!--action操作插槽默认内容-->
          <template v-if="item === 'action'">
            <a-button
              class="add-btn"
              size="small"
              style="font-size: 12px"
              @click="addContrast(record)"
            >
              + 添加对比
            </a-button>
          </template>
        </slot>
      </template>
    </a-table>
  </div>
</template>
<script>
import { sortArrObjByNum } from '@/utils/util'

export default {
  name: 'TableList',
  props: {
    title: {
      type: String,
      default: '',
    },
    sortTitle: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'middle',
    },
    rowKey: {
      type: [String, Function],
      default: 'key',
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    soltName: {
      type: Array,
      default: () => [],
    },
    titleStyle: {
      type: Object,
      default: () => ({}),
    },
    scroll: {
      type: [Object, Boolean],
      default: () => ({ y: 280 }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: [Object, Boolean],
      default: false,
    },
    rowSelection: {
      type: Object,
      default: () => null,
    },
    changeType: {
      type: String,
      default: 'change',
    },
    sortKeys: {
      type: Object,
      default: () => ({ keys: [] }),
    },
    showSelectRowTip: {
      type: Boolean,
      default: false,
    },
    rowClassName: {
      type: Function,
      default: () => null,
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    // 是否隐藏默认排名
    isShowRank: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sortType: '',
      // columns,
      soltNames: [],
    }
  },
  created() {
    this.catchSortName(this.columns)
  },
  methods: {
    addContrast(record) {
      this.$emit('addContrast', record)
    },
    catchSortName(columns) {
      // console.log('进入列表初始化---')
      let soltNames = columns.filter((item) => item.scopedSlots && item.scopedSlots.customRender)
      soltNames = soltNames.length > 0 ? soltNames.map((item) => item.scopedSlots.customRender) : []
      this.soltNames.push(...soltNames)
      // console.log('soltNames----', soltNames)
    },
    chartClick(record) {
      this.$emit('chartClick', this.title, record, this.tableData)
    },
    change(pagination, filters, sorter) {
      this.$emit('change', pagination, filters, sorter)
      // switch (this.changeType) {
      //   case 'pagination':
      //     this.$emit('paginationChange', pagination)
      //     break
      //   case 'filter':
      //     this.$emit('filterChange', filters)
      //     break
      //   case 'sorter':
      //     const data = this.sortTableData(sorter)
      //     this.$emit('sorterChange', sorter, data)
      //     break
      //   default:
      // }

      // if (sorter.order) {
      //   const data = this.sortTableData(sorter)
      //   this.$emit('sorterChange', sorter, data)
      //   return
      // }
    },
    sortTableData(sorter) {
      if (this.changeType == 'sorter') {
        const newTableData = sortArrObjByNum(
          this.tableData,
          sorter.columnKey,
          sorter.order,
          this.sortKeys.keys
        )
        return newTableData
      }
    },
    clearSelected() {
      this.$emit('clearSelected')
    },
    handleScroll(e) {
      console.log('滚动事件--', e)
    },
  },
}
</script>
<style lang="less" scoped>
.table-list {
  box-sizing: border-box;
  min-height: 200px;

  .curr-table {
    ::v-deep {
      .ant-table-header {
        background-color: #f4f7fa !important;
        border-radius: 8px !important;
      }

      .ant-table-thead > tr > th {
        border-bottom: none !important;
        background-color: #f4f7fa;
        font-size: 14px;
        font-weight: bold;
      }

      .ant-table-tbody > tr > td {
        border-bottom: none !important;
      }

      .ant-table-row {
        border-bottom: none !important;
      }
    }
  }

  /deep/ .ant-table-small {
    border: none !important;
  }

  .frontIndex {
    color: #1783e8;
    font-weight: bold;
  }

  .chart {
    width: 50px;
    height: 15px;
    margin-left: 8px;
  }

  .ranking-cell {
    display: flex;
    align-items: center;

    .text {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .rank-img {
      display: flex;
      align-items: center;
      margin-left: 4px;
      width: 18px;
      height: 16px;
    }

    .empty-img {
      margin-left: 4px;
      width: 20px;
      height: 16px;
    }
  }

  .add-btn {
    background-color: #ffffff;
    color: #1890ff;
    border-color: #eff2f5;
    text-shadow: none;
    box-shadow: none;
  }
}
</style>
